import { Link, useLocation } from 'react-router-dom';
import { FaTags, FaBuilding, FaCogs, FaUserShield } from 'react-icons/fa';
import { useAuth } from '../../auth/AuthContext';
import '../../styles/Admin.css';

const TABS = [
    {
        path: '/admin/usage-taxonomy',
        label: 'Usages',
        icon: <FaTags />,
        title: "Taxonomie d'usages",
        description: "Catégories et sous-catégories qui classent le type d'usage des points d'eau, utilisées partout dans l'audit et les tableaux de bord.",
    },
    {
        path: '/admin/building-types',
        label: 'Types de bâtiment',
        icon: <FaBuilding />,
        title: 'Types de bâtiment',
        description: "Liste proposée dans le formulaire de création ou d'édition d'un bâtiment.",
    },
    {
        path: '/admin/machine-types',
        label: 'Types de machine',
        icon: <FaCogs />,
        title: 'Types de machine',
        description: "Types de machine technique disponibles pour un point d'eau, avec leurs champs techniques spécifiques.",
    },
    {
        path: '/admin/users',
        label: 'Comptes',
        icon: <FaUserShield />,
        title: 'Comptes',
        description: "Comptes de l'équipe et des clients : invitations, rôles, clients rattachés, sessions et jetons du connecteur Claude.",
        adminOnly: true,
    },
];

const AdminTabs = () => {
    const { pathname } = useLocation();
    const { isAdmin } = useAuth();
    const current = TABS.find((tab) => tab.path === pathname) || TABS[0];
    const tabs = TABS.filter((tab) => !tab.adminOnly || isAdmin || tab === current);

    return (
        <>
            <div className="admin-page-header">
                <div className="admin-header-icon">{current.icon}</div>
                <div className="admin-header-text">
                    <h1>{current.title}</h1>
                    <p>{current.description}</p>
                </div>
            </div>

            <div className="admin-tab-bar">
                {tabs.map((tab) => (
                    <Link key={tab.path} to={tab.path}
                        className={`admin-tab-pill${pathname === tab.path ? ' active' : ''}`}>
                        {tab.icon}
                        {tab.label}
                    </Link>
                ))}
            </div>
        </>
    );
};

export default AdminTabs;
